import { createDirective } from "./directive";

export function install(Vue, options) {
  var vm = new Vue({
    data: {
      validate: true,
      isModified: false
    }
  });

  options = options || {};
  if (!Vue.prototype.$isServer) {
    Vue.directive(options.name || "prevent-back", createDirective(options, vm));
  } else {
    Vue.directive(options.name || "prevent-back", {});
  }

  Object.defineProperties(Vue.prototype, {
    $validate: {
      get: function() {
        return vm.validate;
      },
      set: function(value) {
        vm.validate = value;
        return this;
      }
    },
    $isModified: {
      get: function() {
        return vm.isModified;
      },
      set: function(value) {
        vm.isModified = value;
        return this;
      }
    }
  });
}

if (typeof window !== "undefined" && window.Vue) {
  install(window.Vue);
}

export default {
  install
};



//////////////////
// WEBPACK FOOTER
// ./Helpers/Plugins/directive/index.js
// module id = null
// module chunks = 